export enum QuestionModeEnum {
    Group = 1,
    SingleAnswer = 2,
    MultipleAnswers = 3,
    ComplexQuestion = 4
}